export default __webpack_public_path__ + "static/media/rules.1a8ca12a.svg";